<template>
    <div class="page">
      <div class="content">
        <div class="top_head">
            <h2 v-show="!listShow">询单标准化推荐</h2>
            <h2 v-show="listShow && tableData.length !== 0">根据录入的信息，小助手为您推荐以下达人</h2>
            <h2 v-show="listShow && tableData.length === 0">正在为您推荐符合条件的达人...</h2>
            <p>根据录入信息，智能推荐达人</p>
        </div>
        <div>
          <div class="condition">
            <div class="option_box">
                <h3>您要推广的内容</h3>
                <div class="input_boxs">
                    <div class="input_box">
                        <span class="box_title">产品形态</span>
                        <el-select v-model="productStyleChoose" placeholder="请选择">
                          <el-option
                            v-for="item in productStyle"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                    </div>
                    <div class="input_box">
                        <span class="box_title">营销标的/类型</span>
                        <el-cascader
                          placeholder="请先选择产品形态"
                          :options="marketingTargetCur"
                          :props="{multiple: true}"
                          @change="marketingTargeChange"
                          ref="myCascader"
                          clearable></el-cascader>
                    </div>
                </div>
            </div>
            <div class="option_box">
                <div class="extension">
                    <span class="box_title">预算</span>
                    <div class="sel_price">
                        <div class="price_out" v-for="item of extension_options" :key="item.id">
                            <div class="option_price" :class="item.checked ? 'active' : ''" @click="setPrice(item)">
                                <h4>{{item.name}}</h4>
                                <div class="price_input" v-if="item.toInput">
                                    <input type="text" v-model="price" @blur="setPriceName(item)" @onblur="setPriceName(item)" ref="toInput">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
          <div class="btn_box">
              <div class="btn" @click="matching('search')">智能推荐</div>
          </div>
        </div>
        <div v-show="!listShow" class="list">
          <div class="noData">{{noDataTest}}</div>
        </div>
        <div v-show="listShow" class="list">
          <div class="kol_table">
            <el-table :data="tableData" style="width: 100%" header-row-class-name='thead_style' @sort-change="sort"
              ref="dataTable" @row-dblclick='tableBtnClick'>
              <el-table-column fixed prop="date" label="日期" width="220">
                <template slot="header" slot-scope="scope">
                  <div class="mcn_num">
                    <div v-if="false">{{scope.row.id}}</div>
                    <div class="num_1">共{{pagination.total_count}}位</div>
                  </div>
                </template>
                <template slot-scope="scope">
                  <div class="mcn_info">
                    <img class="head" :src="scope.row.avatar_uri" alt="">
                    <div class="mcn_detail">
                      <h4 class="name">{{scope.row.nick_name}}</h4>
                      <div class="tag">{{scope.row.tags_relation?scope.row.tags_relation:"-"}}</div>
                      <div class="addr" v-if="scope.row.gender===1"> <img class="sex_icon" src="@/assets/man.png"
                        style="width: 20px;height: 20px;"> {{scope.row.province}} -
                        {{scope.row.city}}</div>
                      <div class="addr" v-if="scope.row.gender===2"> <img class="sex_icon" src="@/assets/woman.png"
                        style="width: 20px;height: 20px;"> {{scope.row.province}} -
                        {{scope.row.city}}</div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="prospective_20_60_cpm" width="120">
                <template slot="header">
                  <div class="table_header_title" @click="sort({prop: 'expected_cpm'})" style="cursor:pointer">
                    预期CPM
                    <el-tooltip effect="dark" content="基于账号预计播放量与当前报价计算的千次播放量费用预估，仅作参考" placement="bottom">
                      <img src="@/assets/question.png" class="question" alt="">
                    </el-tooltip>
                    <i class="el-icon-caret-top" :style="{color:(sortData.expected_cpm?'#FF6F28':'#C0C4CC')}"></i>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="fans_increment_rate_within_15d" sortable="fans_increment_rate_within_15d" min-width="140">
                <template slot="header">
                  <div class="table_header_title">
                    粉丝增长率
                    <el-tooltip effect="dark" content="近15日粉丝增长率" placement="bottom">
                      <img src="@/assets/question.png" class="question" alt="">
                    </el-tooltip>
                  </div>
                </template>
                <template slot-scope="scope">
                  <div>
                    {{scope.row.fans_increment_rate_within_15d ? ((scope.row.fans_increment_rate_within_15d * 100).toFixed(2) + '%') : '-'}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="fans_increment_within_15d" sortable="fans_increment_within_15d" min-width="140">
                <template slot="header">
                  <div class="table_header_title">
                    粉丝增长量
                    <el-tooltip effect="dark" content="近15日粉丝增长量" placement="bottom">
                      <img src="@/assets/question.png" class="question" alt="">
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="price_1_20" label="1-20s报价" sortable='price_1_20' width="140">
                <template slot-scope="scope">
                  <div class="price_text">
                    ￥{{scope.row.price_1_20 ? scope.row.price_1_20.toLocaleString() : '-'}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="price_20_60" label="21-60s报价" sortable='price_20_60' width="140">
                <template slot-scope="scope">
                  <div class="price_text">
                    ￥{{scope.row.price_20_60 ? scope.row.price_20_60.toLocaleString() : '-'}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column fixed="right" prop="price_60" label="60s以上报价" sortable='price_60' width="140">
                <template slot-scope="scope">
                  <div class="price_text">
                    ￥{{scope.row.price_60 ? scope.row.price_60.toLocaleString() : '-'}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="80">
                <template slot-scope="scope">
                  <button class="table_btn" @click="tableBtnClick(scope.row)">详情</button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pages">
            <el-pagination background layout="prev, pager, next" :total="pagination.total_count"
              :current-page="currentPage" @current-change='pageChange' :page-size="pagination.limit">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
  export default {
    data() {
      return {
        listShow:false,
        productStyle:[],
        productStyleChoose:"",
        marketingTarget:{},
        marketingTargetCur:[],
        marketingTargetChoose:{sec:[],third:[]},
        extension_options: [],
        price: '',
        priceSelect: -1,
        tableData:[],
        noDataTest:'暂无数据',
        pagination:{
          has_more: true,
          limit: 20,
          page: 1,
          total_count: 0,
        },
        currentPage:1,
        sortData:{
          price:"",
          expected_cpm:1,
          fans_increment_rate_within_15d:"",
          fans_increment_within_15d:""
        }
      }
    },
    created(){
      this.getData()
    },
    methods: {
      getData(){
        this.$api.orderRecommend.getXdOption().then((res) => {
          let data = res.data.data

          let productStyle = []
          for(let v in data.first){
            productStyle.push({
              value: v,
              label: data.first[v]
            })
          }
          this.productStyle = productStyle

          let marketingTarget ={}
          for(let key in data.sec){
            marketingTarget[key]=[]
            let sec = data.sec[key]
            for(let k in sec){
              let obj = {}
              obj.value = k
              obj.label = sec[k].name
              obj.parId = sec[k].parId
              obj.children = []
              let chId = sec[k].chId
              for(let c in chId){
                obj.children.push({
                  value: c,
                  label: chId[c]
                })
              }
              marketingTarget[key].push(obj)
            }




          }
          this.marketingTarget = marketingTarget

          let extension_options = []
          data.ys.map((item,index)=>{
            extension_options.push({
              name: `${item.ge/10000}~${item.le/10000}万`,
              describe: '',
              checked: false,
              id: index,
              budget: item.le,
              budget_min: item.ge
            })
          })
          extension_options.push({
            name: '自定义（万）',
            describe: '',
            checked: false,
            id: 7,
            toInput: true,
            budget: 0,
            budget_min: 0
          })
          this.extension_options = extension_options
        })
      },
      setPrice(val){
        this.extension_options = this.extension_options.map(t => {
        t.checked = false
            return t
        })
        val.checked = true
        this.priceSelect = val.budget_min
        if ('toInput' in val) {
            val.toInput = true
            this.$nextTick(function () {
                this.$refs.toInput[0].focus()
            })
        }
      },
      setPriceName(){
        this.extension_options[7].budget_min = parseFloat(this.price) * 10000
        this.priceSelect = this.extension_options[7].budget_min
      },
      marketingTargeChange(value) {
        let marketingTargetChoose = {sec:[],third:[]}
        value.map(item=>{
          marketingTargetChoose.sec.push(item[0])
          marketingTargetChoose.third.push(item[1])
        })
        marketingTargetChoose.sec=Array.from(new Set(marketingTargetChoose.sec))
        marketingTargetChoose.third=Array.from(new Set(marketingTargetChoose.third))
        this.marketingTargetChoose = marketingTargetChoose
      },
      parseData(data) {
        if (data instanceof Array) {
          data.forEach((x) => {
            this.parseData(x);
          });
        } else if (Object.prototype.toString.call(data) === "[object Object]") {
          for (const key in data) {
            if (typeof data[key] === "string") {
              data[key] = data[key] ? JSON.parse(data[key]) : "";
            } else {
              this.parseData(data[key]);
            }
          }
        }
      },
      matching(type){
        LA.track('xd_stand_rec');
        this.listShow = false
        this.noDataTest = "正在为您推荐符合条件的达人..."
        if(type==="search"){this.currentPage=1}
        let sec = ''
        let third = ''
        this.marketingTargetChoose.sec.map(item=>{
          sec+=item+','
        })
        this.marketingTargetChoose.third.map(item=>{
          third+=item+','
        })
        sec = sec.slice(0,sec.length-1)
        third = third.slice(0,third.length-1)
        let param = `page=${this.currentPage}&first=${this.productStyleChoose}&sec=${sec}&third=${third}&ys=${this.priceSelect}`
        for(let key in this.sortData){
          if(this.sortData[key]){
            param+=`&order_by=${key}&sort_type=${this.sortData[key]}`
          }
        }
        this.noDataTest='正在为您推荐符合条件的达人...'
        this.$api.orderRecommend.getXdList(param).then((res) => {
          console.log(res.data, 233223);
          if(res.data.code===0&&res.data.data.authors.length>0){
            // let tableData = res.data.data.authors
            let tableData = res.data.data.authors.map((item) => {
              this.parseData(item.attribute_datas)
              return {
                ...item, //自己的字段
                ...item.attribute_datas, //巨量字段
              };
            });
            tableData.map((item,i)=>{
              if(JSON.stringify(item.tags_relation)==='[]'){
                tableData[i].tags_relation="-"
              }else{
                tableData[i].tags_relation=item.tags_relation[Object.keys(item.tags_relation)[0]][0]
              }
            })
            this.tableData = tableData
            this.pagination = res.data.data.pagination
            this.listShow = true
          }else if(res.data.code==="100012"||res.data.code==="100013"||res.data.code==="100015"){
            this.noDataTest='没有匹配的达人'
            this.$message({
              message: res.data.error,
              type: 'error'
            });
          }else{
            this.noDataTest='没有匹配的达人'
          }
        })
      },
      tableBtnClick(val){
        let routeData = this.$router.resolve({
          path: '/daren',
          query: {
            id: val.id
          }
        })
        window.open(routeData.href, "_blank");
      },
      pageChange(val) {
        this.currentPage = val
        this.matching()
      },
      sort(val) {
        let sortData={
          price:"",
          expected_cpm:"",
          fans_increment_rate_within_15d:"",
          fans_increment_within_15d:""
        }
        if(val.prop==="price"){
          if(val.order==="descending"){
            sortData.price=2
          }else if(val.order==="ascending"){
            sortData.price=1
          }else{
            sortData.price=""
          }
        }else if(val.prop==="expected_cpm"){
          if(this.sortData.expected_cpm){
            sortData.expected_cpm=""
          }else{
            sortData.expected_cpm=1
          }
        }else if(val.prop==="fans_increment_rate_within_15d"){
          if(val.order==="descending"){
            sortData.fans_increment_rate_within_15d=2
          }else if(val.order==="ascending"){
            sortData.fans_increment_rate_within_15d=1
          }else{
            sortData.fans_increment_rate_within_15d=""
          }
        }else if(val.prop==="fans_increment_within_15d"){
          if(val.order==="descending"){
            sortData.fans_increment_within_15d=2
          }else if(val.order==="ascending"){
            sortData.fans_increment_within_15d=1
          }else{
            sortData.fans_increment_within_15d=""
          }
        }
        this.sortData = sortData
        this.currentPage = 1
        this.matching()
      }
    },
    watch:{
      price(val, oldval) {
        if (val === '') {
          return
        }
        if (!(/^(0|[1-9][0-9]*)$/.test(val))) {
          this.price = oldval
          return;
        }
        if (parseInt(val) > 10000) {
          this.price = '10000'
          this.$message({
            message: '最大金额不超过1亿元',
            type: 'error'
          });
        }
      },
      productStyleChoose(val, oldval){
        this.marketingTargetCur = this.marketingTarget[val]
        this.$refs.myCascader.$refs.panel.checkedValue = []; // 清空选中值
        this.$refs.myCascader.$refs.panel.clearCheckedNodes(); // 清空级联选择器选中状态
        this.$refs.myCascader.$refs.panel.activePath = []; // 清除高亮
        this.$refs.myCascader.$refs.panel.syncActivePath(); // 初始化（只展示一级节点）
      }
    }
  }
</script>
<style scoped>
  h1,
  h2,
  h3,
  h4,
  h5,
  p {
    margin: 0;
    padding: 0;
  }

  .content {
    width: 1200px;
    margin: 0 auto;

  }

  .content .top_head {
    display: flex;
    flex-direction: column;
    background: url(../../assets/orderRecommend/header_bg.png);
    background-size: contain;
    width: 100%;
    height: 148px;
    border-radius: 6px;
    padding: 45px 40px;
    box-sizing: border-box;
    justify-content: space-between;
  }

  .content .top_head h2 {
    font-size: 20px;
    font-weight: 500;
    color: #FFFFFF;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  }

  .content .top_head p {
    font-size: 14px;
    font-weight: 500;
    color: #FFFFFF;
    opacity: 0.72;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  }

  .content .condition {
    width: 100%;
    margin-top: 20px;
    background: #fff;
    box-sizing: border-box;
    padding: 30px 30px;
    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
    border-bottom: 1px solid #F5F5F6;
  }

  .content .condition h3 {
    font-size: 16px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: bold;
    color: #333333;
    position: relative;
    width: max-content;
  }

  .content .condition h3::after {
    font-size: 16px;
    content: '*';
    position: absolute;
    top: 0;
    right: -10px;
    color: #FF6F28;
  }

  .content .el_sel>>>.el-input__inner {
    width: 220px;
    height: 34px;
    background: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-radius: 2px;
  }

  .condition .option_box+.option_box {
    margin-top: 30px;
  }


  .input_boxs {
    display: flex;
    margin-top: 20px;
    align-items: center;
  }

  .input_boxs .input_box {
    display: flex;
    flex-direction: column;
  }

  .input_boxs .input_box+.input_box {
    margin-left: 24px;
  }

  .option_box .box_title {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #999999;
    margin-bottom: 12px;
  }

  .input_boxs .input_box .el_input>>>.el-input__inner {
    width: 360px;
    height: 34px;
    background: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-radius: 2px;
  }

  .check_boxs {
    display: flex;
    flex-wrap: wrap;
  }

  .check_boxs .check_box {
    width: 340px;
    height: 84px;
    background: #FFFFFF;
    border: 1px solid #D0D3D9;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 21px 24px;
    display: flex;
    align-content: center;
    justify-content: space-between;
    position: relative;
    cursor: pointer;
    margin-top: 24px;
    margin-right: 20px;
  }

  .check_boxs .check_box:nth-child(3n) {
    margin-right: 0px;
  }

  .check_boxs .check_box.active {
    border: 1px solid #FF5C00;
  }

  .check_boxs .check_box.active::before,
  .extension .sel_price .option_price.active::before {
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    background: url(../../assets/help/checked_1.png) no-repeat;
    width: 26px;
    height: 26px;
  }

  .check_boxs .check_box .check_img {
    width: 42px;
    height: 42px;
    background: #FFFFFF;
    border: 1px solid #D0D3D9;
    border-radius: 50%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .check_boxs .check_box.active .check_img {
    border: 1px solid #FF6F28;
  }

  .check_boxs .check_box .check_info {
    width: 235px;
    height: 42px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }

  .check_boxs .check_box .check_info h4 {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #333333;
  }

  .check_boxs .check_box.active .check_info h4 {
    color: #FF5C00;
  }

  .check_boxs .check_box .check_info p {
    font-size: 12px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #999999;
  }

  .extension {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
  }

  .extension .sel_price {
    display: flex;
  }

  .extension .sel_price .option_price {
    width: 100px;
    height: 60px;
    border: 1px solid #D0D3D9;
    border-radius: 4px;
    box-sizing: border-box;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    cursor: pointer;
    position: relative;
  }

  .extension .sel_price .price_out:nth-last-of-type(1) .option_price{
      position: relative;
      width: 200px;
  }
  .extension .sel_price .price_out:nth-last-of-type(1) .option_price h4{
      float: left;
      width: 120px;
  }

  .extension .sel_price .option_price .price_input {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 107px;
    margin: auto 0;
    width: 70px;
    height: 32px;
    border-radius: 4px;
    box-sizing: border-box;
  }

  .extension .sel_price .option_price .price_input input {
    display: block;
    width: 70px;
    height: 32px;
    padding: 0 10px;
    background: #FFFFFF;
    border: 1px solid #D0D3D9;
    border-radius: 4px;
    box-sizing: border-box;
    color: #333;
  }

  .extension .sel_price .option_price .price_input input:focus-visible {
    outline: none;
    border-color: #FF5C00;
    color: #FF5C00;
  }
  .extension .sel_price .option_price.active  .price_input input {
    outline: none;
    border-color: #FF5C00;
    color: #FF5C00;
  }

  .extension .sel_price .option_price.active {
    border: 1px solid #FF5C00;
  }

  .extension .sel_price .option_price.active h4 {
    color: #FF5C00;
  }

  .extension .sel_price .price_out+.price_out {
    margin-left: 20px;
  }

  .extension .sel_price .option_price h4 {

    line-height: 60px;
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #333333;
  }

  .extension .sel_price .option_price p {
    font-size: 12px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #999999;
  }

  .extension .sel_price .option_price p.active {
    color: #FF5C00;
  }

  .option_box .portrait {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
  }

  .option_box .portrait .portrait_box {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
  }

  .option_box .portrait .portrait_box .Gender_box {
    display: flex;
  }

  .option_box .portrait .portrait_box .Gender_box .Gender {
    width: 100px;
    height: 34px;
    background: #FFFFFF;
    border: 1px solid #E0E0E0;
    text-align: center;
    line-height: 34px;
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    color: #333333;
    position: relative;
    margin-left: -1px;
    z-index: 0;
    cursor: pointer;
  }

  .option_box .portrait .portrait_box .Gender_box .Gender.active {
    background: #FFF2EB;
    border: 1px solid #FF5C00;
    z-index: 1;
  }

  .option_box .portrait .portrait_box .Gender_box .Gender:nth-child(1) {
    margin-left: 0;
    border-radius: 2px 0px 0px 2px;
  }

  .option_box .portrait .portrait_box .Gender_box .Gender:nth-last-child(1) {
    border-radius: 0px 2px 2px 0px;
  }

  .option_box .portrait .portrait_box .Gender_box .age {
    width: 100px;
    height: 34px;
    background: #FFFFFF;
    border: 1px solid #E0E0E0;
    text-align: center;
    line-height: 34px;
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    color: #333333;
    position: relative;
    margin-left: -1px;
    z-index: 0;
    cursor: pointer;
  }

  .option_box .portrait .portrait_box .Gender_box .age.active {
    background: #FFF2EB;
    border: 1px solid #FF5C00;
    z-index: 1;
  }

  .option_box .portrait .portrait_box .Gender_box .age::after {
    content: '';
    width: 0px;
    height: 0px;
    border-right: 3px solid #E0E0E0;
    border-left: 3px solid transparent;
    border-top: 3px solid #E0E0E0;
    border-bottom: 3px solid transparent;
    top: 0;
    right: 0;
    position: absolute;
  }

  .option_box .portrait .portrait_box .Gender_box .age.active::after {
    border-right: 3px solid #FF5C00;
    border-left: 3px solid transparent;
    border-top: 3px solid #FF5C00;
    border-bottom: 3px solid transparent;
  }

  .option_box .portrait .select_area {
    display: flex;
    margin-top: 10px;
  }

  .option_box .portrait .select_area .box {
    width: 200px;
    height: 239px;
    border-radius: 2px;
    margin-right: 16px;
    border: 1px solid #E0E0E0;
    box-sizing: border-box;
  }

  .option_box .portrait .select_area .box .title {
    width: 200px;
    height: 39px;
    background: #F0F0F0;
    border: 1px solid #E0E0E0;
    border-radius: 2px;
    box-sizing: border-box;
    padding: 10px 12px;
    display: flex;
    box-sizing: border-box;
    margin: -1px 0 0 -1px;
  }

  .option_box .portrait .select_area .box .title h5 {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    color: #333333;
  }

  .option_box .portrait .select_area .box .title div {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    color: #38A1FF;
    margin-left: auto;
    cursor: pointer;
  }

  .option_box .portrait .select_area .box .area_option {
    width: 100%;
    height: 200px;
    overflow: scroll;
    padding-top: 8px;
    box-sizing: border-box;
  }

  .option_box .portrait .select_area .box .area_option .area {
    width: 100%;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    color: #333333;
    height: 30px;
    padding-left: 12px;
    box-sizing: border-box;
  }

  .option_box .portrait .select_area .box .area_option .area:hover {
    cursor: pointer;
    background: #F5F5F5;
  }

  .option_box .portrait .select_area .box .area_option .area i {
    display: inline-block;
    width: 16px;
    height: 16px;
    background: #FFFFFF;
    border: 1px solid #E9E9E9;
    border-radius: 2px;
    margin-right: 8px;
    box-sizing: border-box;
  }

  .option_box .portrait .select_area .box .area_option .area.active i {
    background-color: #FF6F28;
    border: 1px solid #FF6F28;
    position: relative;

  }

  .option_box .portrait .select_area .box .area_option .area.active i::before {
    content: '';
    background: url(../../assets/help/checked.png) no-repeat;
    width: 10px;
    height: 9px;
    position: absolute;
    top: 2px;
    left: 2px;
    z-index: 2;
  }

  .option_box .portrait .select_area .box .Selected {
    width: 100%;
    height: 200px;
    overflow: scroll;
    padding: 12px;
    box-sizing: border-box;
    position: relative;
  }

  .option_box .portrait .select_area .box .Selected .Selected_item {
    width: 158px;
    height: 26px;
    background: #F5F5F5;
    border-radius: 2px;
    position: relative;
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    color: #333333;
    line-height: 26px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    cursor: pointer;
  }

  .option_box .portrait .select_area .box .Selected .Selected_item+.Selected_item {
    margin-top: 10px;
  }

  .option_box .portrait .select_area .box .Selected .Selected_item i {
    background: url(../../assets/help/cancel.png);
    display: flex;
    width: 8px;
    height: 8px;
    margin-left: auto;
  }

  .option_box .portrait .select_area .box .Selected .nothing {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .option_box .portrait .select_area .box .Selected .nothing i {
    background: url(../../assets/help/nothing_1.png);
    width: 39px;
    height: 35px;
    margin-bottom: 10px;
  }

  .option_box .portrait .select_area .box .Selected .nothing p {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    color: #999999;
  }

  .option_box .like_style {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
  }

  .option_box .like_style>div {
    width: 100px;
    height: 34px;
    text-align: center;
    line-height: 34px;
    margin-right: 10px;
    box-sizing: border-box;
    border-radius: 2px;
    background: #F9F9F9;
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    color: #333333;
  }

  .option_box .like_style>div.active {
    background: #FFF2EB;
    border: 1px solid #FF5C00;
    line-height: 32px;
    color: #FF5C00;
  }

  .option_box .like_style .style_checked {
    position: relative;
  }

  .option_box .like_style .style_checked::after {
    content: '';
    background: url(../../assets/help/nochecked.png);
    width: 19px;
    height: 19px;
    position: absolute;
    top: 0;
    right: 0;
  }

  .option_box .like_style .style_checked.active::after {
    content: '';
    background: url(../../assets/help/checked_2.png);
    width: 17px;
    height: 17px;
    position: absolute;
    top: 0;
    right: 0;
  }

  .btn_box {
    padding: 30px 0;
    box-sizing: border-box;
    background: #fff;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    display: flex;
    justify-content: center;
  }

  .btn_box .btn {
    width: 160px;
    height: 46px;
    background: #FF6F28;
    border-radius: 2px;
    font-size: 15px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 46px;
    text-align: center;
  }

  .btn_box .btn:hover {
    background: #FF5E0E;
    cursor: pointer;
  }





  .content .list {
    margin-top: 20px;
    width: 100%;
    background: #FFFFFF;
    border-radius: 6px;
  }

  .content .list .matchingInfo {
    width: 100%;
    height: 52px;
    background: #FAFAFA;
    border-radius: 6px 6px 0px 0px;
    display: flex;
    box-sizing: border-box;
    padding: 0 26px;
    align-items: center;
  }

  .content .list .matchingInfo .title {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #A3A3A3;
    margin-right: 15px;
  }

  .content .list .matchingInfo .info {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #666666;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 980px;
  }

  .content .list .matchingInfo .btn {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #FF6F28;
    margin-left: auto;
    cursor: pointer;
  }

  .content .list .rec {
    display: flex;
    box-sizing: border-box;
    padding: 0 26px;
    margin-top: 30px;
  }

  .content .list .rec h5 {
    font-size: 16px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #333333;
    margin-right: 30px;
  }

  .content .list .rec .btn {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #38A1FF;
    cursor: pointer;
  }

  .content .list .rec .btn i {
    transform: rotate(90deg);
  }

  .content .list .keywords {
    display: flex;
    align-items: center;
    margin-top: 20px;
    box-sizing: border-box;
    padding: 0 26px;
  }

  .content .list .keywords p {
    margin-right: 20px;
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #666666;
  }

  .content .list .keywords .keyword {
    width: 90px;
    height: 29px;
    background: #FAFAFA;
    border-radius: 2px;
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #666666;
    line-height: 29px;
    text-align: center;
    cursor: pointer;
  }

  .content .list .keywords .keyword+.keyword {
    margin-left: 16px;
  }

  .content .list .keywords .keyword.active {
    box-sizing: border-box;
    line-height: 27px;
    border: 1px solid #FF5C00;
    background: #FFF2EB;
    color: #FF6F28;
  }

  .content .list .datas {
    box-sizing: border-box;
    padding: 0 26px;
  }

  .content .list .datas .item {
    display: flex;
    align-items: center;
    height: 154px;
    width: 100%;
    border-bottom: 1px solid #F0F0F0;
  }

  .content .list .datas .item:nth-last-child(1) {
    border-bottom: none;
  }

  .content .list .datas .item img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    border: 1px solid #e0e0e0;
  }

  .content .list .datas .item .info {
    margin-left: 20px;
    width: 430px;
  }

  .content .list .datas .item .info h2 {
    display: block;
    margin-top: 10px;
    font-size: 16px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #333333;
  }

  .content .list .datas .item .info .cate {
    display: inline-block;
    height: 26px;
    background: #F6F6F6;
    border-radius: 2px;
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    color: #333333;
    line-height: 26px;
    text-align: center;
    padding: 0 10px;
    margin: 12px 0;
  }

  .content .list .datas .item .info .tags {
    display: flex;
  }

  .content .list .datas .item .info .tags .tag {
    height: 24px;
    background: #FFF2EB;
    border-radius: 2px;
    font-size: 12px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #FF6F28;
    line-height: 24px;
    padding: 0 10px;
  }

  .content .list .datas .item .info .tags .tag+.tag {
    margin-left: 8px;
  }

  .content .list .datas .item .num {
    width: 100px;
  }

  .content .list .datas .item .num div {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 800;
    color: #666666;
    text-align: center;
  }

  .content .list .datas .item .num p {
    margin-top: 6px;
    font-size: 12px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #999999;
    text-align: center;
  }

  .content .list .datas .item .line {
    width: 1px;
    height: 30px;
    background: #F5F5F6;
    margin: 0 70px;
  }

  .content .list .datas .item .price {
    color: #FF5C00;
    display: flex;
  }

  .content .list .datas .item .price span {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 800;
    margin-top: 9px;
  }

  .content .list .datas .item .price .price_text {
    font-size: 20px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 800;
    color: #FF5C00;
    margin-right: 6px;
  }

  .content .list .datas .item .price .preview:hover {
    cursor: pointer;
  }

  .content .list .datas .item .price .preview i {
    display: block;
    background: url(../../assets/help/preview.png);
    width: 14px;
    height: 14px;
  }

  .content .list .datas .item .btn {
    width: 72px;
    height: 30px;
    background: #FF6F28;
    border-radius: 2px;
    text-align: center;
    line-height: 30px;
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #FFFFFF;
    margin-left: auto;
    cursor: pointer;
  }

  .in_preview {
    padding: 24px;
    box-sizing: border-box;
  }

  .in_preview h3 {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #999999;
    height: 30px;
    border-bottom: 1px solid #F5F5F6;
  }

  .in_preview .price_item {
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .in_preview .price_item .corr_price {
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    color: #FF5C00;
    font-weight: 800;
    display: flex;
  }

  .in_preview .price_item .corr_price span {
    font-size: 14px;
    padding-top: 4px;
  }

  .in_preview .price_item .corr_price .price_t {
    font-size: 18px;
  }

  .noData {
    width: 100%;
    height: 450px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .noData p {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #666666;
    line-height: 32px;
  }

  .datas_noData {
    width: 100%;
    height: 450px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .datas_noData p {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #666666;
    line-height: 32px;
  }
  .pages{
    margin-top: 20px;
    margin-right: 26px;
    padding-bottom: 30px;
  }
  .el-select-dropdown__item.selected{
    color: #FF5C00;
  }
  .page>>>.el-select .el-input.is-focus .el-input__inner,
  .page>>>.el-select .el-input__inner:focus,
  .page>>>.el-cascader .el-input .el-input__inner:focus,
  .page>>>.el-cascader .el-input.is-focus .el-input__inner{
    border-color:#FF5C00;
  }
  .page .mcn_info .head{
    margin-top: 10px;
  }
  .page .el-table .cell .table_header_title{
    display: inline-block;
  }
  .page>>>.el-pagination .btn-next .el-icon,
  .page>>>.el-pagination .btn-prev .el-icon{
    text-align: center;
  }
</style>